var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = function() {
	if (!hasRun) {
		hasRun = true;
		__webpack_require__(32000)
	}
	if (typeof prevStartup === 'function') {
		return prevStartup();
	} else {
		console.warn('[MF] Invalid prevStartup');
	}
};